
export enum UserRole {
    NONE = 0,
    READ_ONLY = 1,
    ADMIN = 20,
    SUPERUSER = 30,
}